import { boolean, object } from "yup";
import { optionalEmail } from "../../../acd/util.js";
import { defaultAddress, defaultContextFields, generateDateBeforeTodayValidationRule, nameAndAddress, optionalCheckbox, } from "../../../shared.js";
export const a3UploadablePart1DataSchema = object({
    ...defaultContextFields(),
    nameAndAddressOfSignee: nameAndAddress({
        nameRequiredError: "Please enter name of signee",
        addressRequiredError: "Please enter address of signee",
    }, true).default(defaultAddress),
    lastExaminedDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter the date first practitioner last examined the patient"),
    previousAcquaintance: boolean()
        .default(null)
        .required("Please select the option which applies"),
    emailAddressOfSignee: optionalEmail,
    practitionerApprovedUnderSection12: boolean()
        .default(null)
        .required("Please confirm if first practitioner is approved under section 12 of the Act"),
    necessaryForPatientsOwnHealth: optionalCheckbox,
    necessaryForPatientsOwnSafety: optionalCheckbox,
    necessaryForProtectionOfOtherPersons: optionalCheckbox.test("at-least-one-detention-reason-selected", "Please select the option(s) which apply", (_, { parent }) => {
        return (parent.necessaryForPatientsOwnHealth ||
            parent.necessaryForPatientsOwnSafety ||
            parent.necessaryForProtectionOfOtherPersons);
    }),
    signatureDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter signature date "),
});
export const a3UploadablePart2DataSchema = object({
    ...defaultContextFields(),
    nameAndAddressOfSignee: nameAndAddress({
        nameRequiredError: "Please enter name of signee",
        addressRequiredError: "Please enter address of signee",
    }, true).default(defaultAddress),
    lastExaminedDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter the date the second practitioner last examined the patient"),
    practitionerApprovedUnderSection12: boolean()
        .default(null)
        .required("Please confirm if second practitioner is approved under section 12 of the Act"),
    emailAddressOfSignee: optionalEmail,
    previousAcquaintance: boolean()
        .default(null)
        .required("Please confirm if second practitioner had previous acquaintance with the patient"),
    signatureDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter signature date "),
});
export const exampleA3UploadableData = [
    {
        data: {
            nameAndAddressOfSignee: {
                name: "name",
                address: "Address",
                isConfirmed: true,
                postalCode: "ABC 123",
            },
            lastExaminedDate: "2021-01-01",
            previousAcquaintance: false,
            emailAddressOfSignee: "stuart@thalamos.co.uk",
            practitionerApprovedUnderSection12: true,
            necessaryForPatientsOwnHealth: true,
            necessaryForPatientsOwnSafety: false,
            necessaryForProtectionOfOtherPersons: false,
            signatureDate: "2021-01-01",
            user: {
                name: "Dr. Sarah Glass",
                address: "143 Fake Street",
                postalCode: "AB1 2CD",
                email: "sarah.glass@houses.com",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: false,
            },
            patient: {
                name: "Bob Smith",
                address: "123 Fake Street",
                postalCode: "AB1 2CD",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
        },
    },
    {
        data: {
            nameAndAddressOfSignee: {
                name: "name",
                address: "Address",
                isConfirmed: true,
                postalCode: "ABC 123",
            },
            lastExaminedDate: "2021-01-01",
            previousAcquaintance: false,
            emailAddressOfSignee: "david@thalamos.co.uk",
            practitionerApprovedUnderSection12: true,
            signatureDate: "2021-01-01",
            user: {
                name: "Dr. Peter Crass",
                address: "143 Fake Street",
                postalCode: "AB1 2CD",
                email: "Peter.Crass@houses.com",
                isConfirmed: true,
                isSection12Approved: false,
                isGuest: false,
            },
            patient: {
                name: "Bob Smith",
                address: "123 Fake Street",
                postalCode: "AB1 2CD",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
        },
    },
];
//# sourceMappingURL=a3.js.map